import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'eic-display-office-address',
  templateUrl: './display-office-address.component.html',
  styleUrls: ['../../project-display.styles.scss',
              './display-office-address.component.scss']
})
export class DisplayOfficeAddressComponent implements OnInit {
  @Input() office: any;

  searchTerm: any;
  address: string;

  ngOnInit() {
   let addressLine1 = !(this.office.addressLine1) ? "" : this.office.addressLine1 + ", ";
    let addressLine2 = !(this.office.addressLine2) ? "" : this.office.addressLine2 + ", ";
    let addressLine3 = !(this.office.addressLine3) ? "" : this.office.addressLine3 + ", ";
    let town = !(this.office.town) ? "" : this.office.town + ", ";
    let county = !(this.office.county) ? "" : this.office.county + ", ";
    let country = !(this.office.country) ? "" : this.office.country;

    this.address = addressLine1
      + addressLine2
      + addressLine3
      + town
      + county
      + county
  }
}
